module.exports = __webpack_public_path__ + "img/asa-logo.04059c64.jpeg";